import React, { ImgHTMLAttributes, useMemo } from 'react';

import { useAppSelector } from 'Store';

interface ImagemProps extends ImgHTMLAttributes<HTMLImageElement> {
    src?: string,
    texto?: string | null;
}

const Imagem = ({src, height, width, texto = null, ...props}: ImagemProps): React.ReactElement =>
{
    const url = useAppSelector(estado => estado.config.urlImagem);

    const urlFinal = useMemo(() => {
        if (!src) {
            const tamanho = [];

            if (width) tamanho.push(width);
            if (height) tamanho.push(height);

            return `https://via.placeholder.com/${tamanho.join('x')}?text=${texto !== null ? texto + '%20' : 'Sem+imagem'}`
        }

        if (src.indexOf('http') != -1) {
            return src;
        }

        return `${url}/${src}`;
    }, [src, url, width, height, texto]);

    return (
        <img src={ urlFinal } width={ width } height={ height } {...props} />
    )
}

export default Imagem;
